module.exports = __webpack_public_path__ + "img/park-cover-2.73a6b973.png";